<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card elevation="0" tile>
        <v-card-title class="grey lighten-4">
          {{ $t("hr.menu.papers") }}
          <v-spacer />
          <id-button @click="onCreate" class="mr-2">
            <template #icon>
              <v-icon left>mdi-plus</v-icon>
            </template>
            {{ $t("buttons.add", []) }}
          </id-button>
          <id-button @click="onRefreshData">
            <template #icon>
              <v-icon left>mdi-refresh</v-icon>
            </template>
            {{ $t("buttons.refresh") }}
          </id-button>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :options.sync="table.options"
          :server-items-length="table.totalItems"
          :loading="table.loading"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
          class="elevation-1"
        >
          <template slot="item" slot-scope="row">
            <tr :active="row.selected">
              <td>
                <v-avatar :color="'red'" size="35">
                  <span class="white--text font-weight-bold"
                    >{{ row.item.paperType.name.substring(0, 2).toUpperCase() }}
                  </span>
                </v-avatar>
                {{ getName(row.item.paperType) }}
              </td>
              <td>
                {{ row.item.issueDate | formattedDate }}
              </td>
              <td>
                {{ row.item.expireDate | formattedDate }}
              </td>
              <td>
                {{ $t(`hr.paper.signature_types.${row.item.signatureStatus}`) }}
              </td>
              <td>
                <file-download-button :url="row.item.url" />
              </td>
              <td>
                <id-button small v-if="row.item.signatureStatus === 'BIOMETRIC_SIGNATURE'">
                  <template #icon>
                    <v-icon small left>mdi-pen</v-icon>
                  </template>
                  {{ $t("buttons.sign") }}
                </id-button>
              </td>
            </tr>
          </template>
        </v-data-table>
        <transition name="slide-in-left">
          <router-view @success:save="onRefreshData" />
        </transition>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  /**
   * @project personal-idenfit
   * @developer Halil Kılıçarslan
   * @description Performance Component Logic
   * @date 28.07.2020
   */

  import { PAPER_PAGINATE, PAPERS } from "../query";

  export default {
    name: "Papers",
    data: vm => ({
      table: {
        loading: false,
        data: [],
        criteria: {
          employee: null
        },
        options: {},
        pagination: {
          rowsPerPage: 10,
          sortBy: "paperType.name",
          descending: false
        },
        totalItems: 0,
        totalPages: 0,
        selected: [],
        headers: [
          {
            text: `${vm.$t("hr.paper.name")}`,
            align: "left",
            sortable: true,
            value: "paperType.name",
            class: ["primary--text"]
          },

          {
            text: vm.$t("hr.paper.issue_date"),
            align: "left",
            sortable: true,
            value: "issueDate",
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.paper.expire_date"),
            align: "left",
            sortable: true,
            value: "expireDate",
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.paper.signature_status"),
            align: "left",
            sortable: false,
            value: "",
            class: ["primary--text"]
          },
          {
            text: "",
            align: "left",
            sortable: false,
            value: "url",
            class: ["primary--text"]
          },
          {
            text: "",
            align: "left",
            sortable: false,
            value: "url",
            class: ["primary--text"]
          }
        ]
      }
    }),
    watch: {
      "table.options": {
        handler(options) {
          let { itemsPerPage, page } = options;
          this.table.pagination.rowsPerPage = itemsPerPage;
          this.table.pagination.page = page;
          this.table.criteria.employee = this.$store.state.auth.user.id;
          this.fetchItems();
        },
        deep: true
      }
    },
    methods: {
      getName(item) {
        return this.$store.state.auth.language === "tr" ? item.name : item.englishName || item.name;
      },
      onRefreshData() {
        this.fetchItems();
      },
      async fetchItems() {
        this.table.loading = true;
        await this.$apollo
          .query({
            query: PAPER_PAGINATE,
            variables: {
              criteria: {
                employee: this.$store.state.auth.user.id
              },
              pagination: this.$helpers.convertPagination(this.table.pagination)
            }
          })
          .then(({ data, errors }) => {
            if (!errors || !data.error) {
              this.table.data = data.filterWithPaginatePapers.content || [];
              this.table.totalItems = data.filterWithPaginatePapers.pageInfo.totalElements || 0;
            }
          })
          .catch(e => {
            this.$helpers.showNotification(e.message);
          })
          .finally(() => (this.table.loading = false));
      },
      onCreate() {
        this.$router.push({ name: "paper_create" });
      }
    }
  };
</script>

<style scoped></style>
